import {AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges} from "@angular/core";

@Directive({
  selector: '[intDropdownAreaItem]'
})
export class IntDropdownAreaItemDirective implements AfterViewInit, OnChanges {
  @Input() isActive = false;
  constructor(
    readonly elementRef: ElementRef,
  ) {}

  ngAfterViewInit() {
    if(this.isActive) {
      this.scrollTo();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['isActive']?.currentValue) {
      this.scrollTo();
    }
  }

  scrollTo() {
    this.elementRef.nativeElement.scrollIntoView({ block: 'start', behavior: "smooth" });
  }
}
